import classNames from "classnames";
import { Error } from "components/InputsMex/containers/components";
import React from "react";
import styled from 'styled-components';
/**
 * @typedef {import("react-number-format").NumberFormatProps} NumberColumnProps
 *
 * @param {NumberColumnProps &
 *  	{
 *  	 	errorMessage:string,
 *  	 	disabled:boolean,
 *  	 	hasError:boolean,
 *      onChange:(value:number)=>void
 *  	}
 * } props
 * @returns
 */
 const ErrorPersonalizado = styled.strong`
 font-family: 'Futura-Medium';
 font-size: 15px;
 color: #cf0e18 !important;
 line-break: normal;
 margin: 0 0 0 0;
 padding-left:5px;
 width: ${(props) => props.width || '100%'} !important;
`;
const TextColumn = (props) => {
  const { value, onChange, hasError, disabled, errorMessage,maxLength=200, index  } = props;
  const clsDisable=disabled?'d-flex flex-row align-items-center clasDisabletd':'d-flex flex-row align-items-center background-white px-1'
  const cssDisable=disabled?" w-100 border-0 p-0 m-0 font-source-sans-regular border-danger disabled-input":"w-100 border-0 p-0 m-0 font-source-sans-regular border-danger"
  return (
    <td
      className={classNames("border v-center text-left py-0 m-0", {
        "border-danger bg-white": hasError,
      })}>
      <div className={clsDisable}>                
        <input
          value={value}
          className={cssDisable}
          style={{ fontWeight: "bold", height: "38px" }}   
          onChange={(evt) => {
            onChange(evt.target.value);
          }}  
          maxLength={maxLength}  
          tabIndex={disabled?-1:index}                    
        />
      </div>
      {errorMessage && <ErrorPersonalizado>{errorMessage}</ErrorPersonalizado>}
    </td>
  );
};

export default TextColumn;
